import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-3"
}
const _hoisted_2 = { class: "my-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref } from 'vue';
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BUCKET_DATA_TYPES } from '@/constants';
import { formatDateStringToIso } from '@/utils/date-utils';
import BucketList from '@/components/data/BucketList.vue';
import { useUserStore } from '@/store/user';
import BucketCreate from '@/components/data/BucketCreate.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataManagerView',
  setup(__props) {

const userStore = useUserStore();
const showNewBucketForm = ref(false);

// --- Component References ---
const bucketListRef = ref<InstanceType<typeof BucketList>>();

// Filter state
const bucketFriendlyNamePattern = ref('');

const dateCreatedAfter = ref<string | null>(null);
const timeCreatedAfter = ref<string | null>(null);
const dateTimeCreatedAfter = ref<string | null>(null);

const dateCreatedBefore = ref<string | null>(null);
const timeCreatedBefore = ref<string | null>(null);
const dateTimeCreatedBefore = ref<string | null>(null);

function onSearchRequested() {
  dateTimeCreatedAfter.value = formatDateStringToIso(
    dateCreatedAfter.value,
    true
  );
  dateTimeCreatedBefore.value = formatDateStringToIso(
    dateCreatedBefore.value,
    true
  );

  bucketListRef.value?.requestSearch();
}

function clearFilter() {
  bucketFriendlyNamePattern.value = '';

  dateCreatedBefore.value = null;
  timeCreatedBefore.value = null;
  dateTimeCreatedBefore.value = null;

  dateCreatedAfter.value = null;
  timeCreatedAfter.value = null;
  dateTimeCreatedAfter.value = null;

  bucketListRef.value?.requestSearch();
}

function onBucketCreated() {
  bucketListRef.value?.requestSearch();
  showNewBucketForm.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'database'] }),
      _cache[5] || (_cache[5] = _createTextVNode(" Data Manager", -1))
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Browse your data and samples", -1)),
    _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
    _cache[12] || (_cache[12] = _createElementVNode("p", null, " Use this data manager to browse and edit your data, and view and annotate samples. ", -1)),
    (_unref(userStore).isAdmin || _unref(userStore).isDeveloper)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(BButton), {
            variant: "outline-dark",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showNewBucketForm.value = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: ['fa', 'plus'],
                class: "me-1"
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" Create New Dataset ", -1))
            ]),
            _: 1
          }),
          (showNewBucketForm.value)
            ? (_openBlock(), _createBlock(BucketCreate, {
                key: 0,
                show: showNewBucketForm.value,
                "default-data-type": _unref(BUCKET_DATA_TYPES).INPUT,
                onSuccess: onBucketCreated,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (showNewBucketForm.value = false))
              }, null, 8, ["show", "default-data-type"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BForm), {
        class: "d-flex flex-row align-items-end flex-wrap gap-2",
        onSubmit: _withModifiers(onSearchRequested, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BFormGroup), {
            label: "Bucket name",
            "label-for": "bucket-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                id: "search-text",
                type: "text",
                modelValue: bucketFriendlyNamePattern.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bucketFriendlyNamePattern).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "Created after",
            "label-for": "date-created-after"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                id: "date-created-after",
                type: "date",
                modelValue: dateCreatedAfter.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateCreatedAfter).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "Created before",
            "label-for": "date-created-before"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                id: "date-created-before",
                type: "date",
                modelValue: dateCreatedBefore.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateCreatedBefore).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BButton), {
            variant: "outline-secondary",
            onClick: clearFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "trash",
                class: "me-1"
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" Clear filter ", -1))
            ]),
            _: 1
          }),
          _createVNode(_unref(BButton), {
            variant: "outline-dark",
            type: "submit",
            disabled: bucketListRef.value?.bucketsQueryInProgress
          }, {
            default: _withCtx(() => [
              (bucketListRef.value?.bucketsQueryInProgress)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_unref(BSpinner), {
                      small: "",
                      label: ""
                    }),
                    _cache[8] || (_cache[8] = _createTextVNode(" Searching ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: "magnifying-glass",
                      class: "me-1"
                    }),
                    _cache[9] || (_cache[9] = _createTextVNode(" Search ", -1))
                  ]))
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _createVNode(BucketList, {
      ref_key: "bucketListRef",
      ref: bucketListRef,
      parentName: "Data Manager",
      "data-type": _unref(BUCKET_DATA_TYPES).INPUT,
      "bucket-friendly-name-pattern": bucketFriendlyNamePattern.value,
      "created-after": dateTimeCreatedAfter.value,
      "created-before": dateTimeCreatedBefore.value
    }, null, 8, ["data-type", "bucket-friendly-name-pattern", "created-after", "created-before"])
  ]))
}
}

})